import Component from 'components/pages/About/About.qmee';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('about');
export default buildPage(Component, {
  requiresAuthentication: false,
  metaData: {
    title: 'About us',
    description: 'About Us Page',
  },
});
